export default __webpack_public_path__ + "static/media/background_nop.bc806136.png";